module.exports = __webpack_public_path__ + "img/background_osp.05522773.png";